import React from "react";
import PropTypes from "prop-types";
import { EVENT_CODE_ENTER } from "../../constants";

/**
 * Link Component (508 compliant)
 * @param {Object} props
 * @param {string} [props.id]
 * @param {string} [props.className]
 * @param {function} props.onClick
 * @param {string} [props.title]
 * @param {React.ReactNode} [props.children]
 * @returns {Element}
 * @constructor
 */
export default function Link({ id, className, onClick, title, children }) {
  return (<div role="button" id={id} className={className} title={title} onClick={onClick} tabIndex={0}
               onKeyDown={(event) => {
                 if (event.key === EVENT_CODE_ENTER) {
                   onClick(event);
                 }
               }}>{children}</div>);
}

Link.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string,
  children: PropTypes.node,
};